/**
 * Shared application header — consistent across all screens.
 * Shows app title, user name, Admin button (if platform admin), and Logout.
 */
import { getCurrentUser, isPlatformAdmin, logout } from '../services/auth';
import { sanitize } from '../services/utils';

export function renderAppHeader(container: HTMLElement): void {
  const user = getCurrentUser();

  const header = document.createElement('header');
  header.id = 'app-header';
  header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:10px 24px;border-bottom:1px solid var(--colorBorder);background:var(--colorBgHeader);flex-shrink:0';

  header.innerHTML = `
    <div style="display:flex;align-items:center;gap:12px;flex:1">
      <a href="#folders" style="display:flex;align-items:center;gap:12px;text-decoration:none">
        <span style="font-size:14px;font-weight:600;color:var(--colorTextHeading)">Use Case Discovery</span>
        <span style="font-size:10px;color:var(--colorTextLight);text-transform:uppercase;letter-spacing:.1em">Worksheet</span>
      </a>
    </div>
    <div style="display:flex;align-items:center;gap:12px">
      <span style="font-size:12px;color:var(--colorTextMuted)">${sanitize(user?.display_name || user?.email || '')}</span>
      ${isPlatformAdmin() ? '<button id="hdr-admin-btn" style="font-size:9px;padding:2px 6px;border-radius:4px;background:var(--colorAccent);color:#fff;text-transform:uppercase;border:none;cursor:pointer;letter-spacing:.05em">Admin</button>' : ''}
      <button id="hdr-logout-btn" style="font-size:11px;color:var(--colorTextLight);background:none;border:none;cursor:pointer">Logout</button>
    </div>
  `;

  // Insert at top of container
  container.prepend(header);

  document.getElementById('hdr-logout-btn')?.addEventListener('click', logout);
  document.getElementById('hdr-admin-btn')?.addEventListener('click', () => { window.location.hash = 'admin'; });
}
